(function(){
  function wireSlideshowArrows(root){
    (root || document).querySelectorAll('.slideshow').forEach(function(ss){
      if (ss.dataset.uliArrows === '1') return; // doppelt verhindern
      ss.dataset.uliArrows = '1';

      // Buttons erzeugen
      var prev = document.createElement('button');
      prev.type = 'button';
      prev.className = 'uli-hint-ctrl uli-hint-ctrl--prev';
      prev.setAttribute('aria-label','Previous slide');

      var next = document.createElement('button');
      next.type = 'button';
      next.className = 'uli-hint-ctrl uli-hint-ctrl--next';
      next.setAttribute('aria-label','Next slide');

      ss.appendChild(prev);
      ss.appendChild(next);

      // Hilfsfunktion: aktives Bullet finden & anclicken
      function clickBullet(delta){
        var wrap = ss.querySelector('.slideshow__pagination-bullets');
        if(!wrap) return;
        var bullets = Array.from(wrap.querySelectorAll('.slideshow__pagination-bullet'));
        if(!bullets.length) return;

        var idx = bullets.findIndex(function(b){ return b.classList.contains('active'); });
        if(idx < 0) idx = 0;
        var target = (idx + delta + bullets.length) % bullets.length;
        bullets[target].click();
      }

      prev.addEventListener('click', function(e){ e.preventDefault(); e.stopPropagation(); clickBullet(-1); });
      next.addEventListener('click', function(e){ e.preventDefault(); e.stopPropagation(); clickBullet(+1); });
    });
  }

  document.addEventListener('DOMContentLoaded', function(){ wireSlideshowArrows(); });
  document.addEventListener('shopify:section:load',   function(e){ wireSlideshowArrows(e.target); });
  document.addEventListener('shopify:section:select', function(e){ wireSlideshowArrows(e.target); });
})();